import { Deserializable } from '../interfaces/deserialize';

export class ClientModel implements Deserializable {
  _id!: string;
  name!: string;
  contact!: {
    telephones: string[];
    _id?: string;
    email: string;
    name: string;
    country: string
  };
  
  erp_code?: string;
  taxValue?: number;
  cod_modalidad?: string;
  companyModality?: string;
  company_type?: string;

  deserialize(obj: any) {
    Object.assign(this, obj);
    return this;
  }

  public getName(): string {
    return this.name;
  }

  public getContact(): string {
    return this.contact && this.contact.name ? this.contact.name : '';
  }
}
